type ActionMap<M extends { [index: string]: any }> = {
	[Key in keyof M]: M[Key] extends undefined
		? {
				type: Key;
		  }
		: {
				type: Key;
				payload: M[Key];
		  };
};

export enum Types {
	SetPhrase = "SET_PHRASE",
	SetFilters = "SET_FILTERS",
}

type SearchType = {
	phrase: string;
	filters: { [key: string]: string[] };
};

type SearchPayload = {
	[Types.SetPhrase]: {
		phrase: SearchType["phrase"];
	};
	[Types.SetFilters]: {
		filters: SearchType["filters"];
	};
};

export type SearchActions = ActionMap<SearchPayload>[keyof ActionMap<SearchPayload>];

export const searchReducer = (state: SearchType, action: SearchActions) => {
	switch (action.type) {
		case Types.SetPhrase:
			return {
				...state,
				phrase: action.payload.phrase,
			};
		case Types.SetFilters:
			return { ...state, filters: action.payload.filters };
		default:
			return state;
	}
};
